<style src="./Result.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="result">
    <span class="description">Escolha a empresa cujo valor será mostrado no quadro</span>
    <ul class="distributorcontainer">
      <li
        v-for="(resultInfo, resultIdx) in result.distributors"
        :key="resultIdx"
        :class="{ 'selected': $store.getters['Distributors/DEFAULT_DISTRIBUTOR_ID'].includes(resultInfo.distributor._id.toString()) }"
        @click="setDefaultDistributor(resultInfo)"
        class="distributor">
        <div class="selected">
          <icon-check class="check" v-if="$store.getters['Distributors/DEFAULT_DISTRIBUTOR_ID'].includes(resultInfo.distributor._id.toString())" />
        </div>
        <span class="name"><p>{{ resultInfo.distributor.name }}</p></span>
        <span class="total"><small>R$&nbsp;</small><strong>{{ resultInfo.total | CurrencyBR }}</strong></span>
      </li>
    </ul>
    <button
      class="btn btn-primary"
      @click="openResult">
      Ir para Resultados
    </button>
  </section>
</template>

<script>
import { CurrencyBR } from '@/components/primitives/helpers/filters'
import { IconCheck } from '@/components/primitives/icons'

export default {
  name: 'Result',
  props: {
    eventId: null
  },
  components: {
    IconCheck
  },
  data () {
    return {
      result: {
        distributors: [],
        defaultDistributor: null,
        totalGlobal: 0
      }
    }
  },
  filters: {
    CurrencyBR
  },
  mounted () {
    this.loadResult()
  },
  methods: {
    async openResult () {
      this.$store.dispatch('Events/OPEN_EVENT_TO_RESULT', {
        eventId: this.eventId,
        route: this.$router
      })
    },
    async loadResult () {
      try {
        await this.$store.dispatch('Distributors/LOAD_DEFAULT')
        const { result } = await this.$store.dispatch('Board/LOAD_RESULT', {
          eventId: this.eventId
        })
        this.result.distributors = result.distributors
        this.result.defaultDistributor = result.defaultDistributor
        this.result.totalGlobal = result.totalGlobal
      } catch (error) {
        this.$toasted.error('Não conseguimos carregar os resultados')
      }
    },
    async setDefaultDistributor (info) {
      const stage = this.$store.getters['Board/STAGE_BY_NAME']('Resultado')
      const payload = {
        eventId: this.eventId,
        stageId: stage._id
      }
      try {
        if (this.result.defaultDistributor && this.result.defaultDistributor === info.distributor._id) {
          this.result.defaultDistributor = null
          payload.distributorId = null
          payload.total = null
          payload.distributorName = null
        } else {
          this.result.defaultDistributor = info.distributor._id
          payload.distributorId = info.distributor._id
          payload.total = info.total
          payload.distributorName = info.distributor.name
        }

        await this.$store.dispatch('Result/SET_DEFAULT_DISTRIBUTOR', payload)
      } catch (error) {
        this.$toasted.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/result/Result.vue